/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/camelcase */
import antdData from 'antd/es/locale/tr_TR';

export const trTR = Object.assign(
  { antdData: antdData },
  {
    migrationSuitableStatus: {
      None: 'İşlem bekliyor',
      WaitingToTransfer: 'Aktarım bekleniyor',
      Suitable: 'Aktarım tamamlandı',
      NotSuitable: 'Aktarımda hata oluştu.',
      TransferStarted: 'Aktarım devam ediyor'
    },
    MAIN: {
      SIGNATURE_APPLICATION: 'IMZA UYGULAMASI',
      TITLE: 'UYGULAMA BAĞLANTISI'
    },
    CONNECTING: {
      MESSAGE: 'e-İmza / Mali Mühür Uygulamasına Bağlanılamadı',
      DESCRIPTION: 'e-İmza / Mali Mühür uygulamasını çalıştırmadan uygulamayı kullanamazsınız. Lütfen uygulamayı aşağıdaki linkten indirip, çalıştırın.',
      DOWNLOAD_LINK: 'e-İmza / Mali Mühür uygulamasını indirmek için <a style="cursor: pointer" href="/apps/NesEImzaSoket-{version}.jar">tıklayınız</a>',
      JAVA_DOWNLOAD_LINK:
        'Bilgisayarınız <b>Java</b> kurulu olmalıdır. <b>Java</b> kurulu <b>değilse</b>, kurmak için buraya <a href="https://www.java.com/inc/BrowserRedirect1.jsp?locale=tr"><b>tıklayınız.</b></a>',
      REQUIREMENTS_1: 'e-İmza / Mali Mühürün bilgisayarınıza takılı olması gerekmektedir.',
      REQUIREMENTS_2: 'e-İmza / Mali Mühür uygulamasının, işlem bitene kadar açık kalması gerekmektedir.',
      REQUIREMENTS_3: 'e-İmza / Mali Mühür sürücülerinin kurulu olması gerekmektedir.',
      REQUIREMENTS_4: 'e-İmza / Mali Mühür yazılımlarının kurulu olması gerekmektedir. (AKİS, vb.)',
      AUTO_CONNECT_DESCRIPTION: 'Uygulamayı başlattığınızda otomatik olarak bağlanılacaktır, lütfen uygulamayı çalıştırın.',
      RETRY: 'Tekrar Dene'
    },
    SMART_CARD_LOGIN: {
      DESCRIPTION: 'İmzalama işlemleri için öncelikle akıllı kartınıza giriş yapmanız gerekmektedir.',
      TITLE: 'Akıllı karta giriş yap',
      USE_WRAPPER: 'Akıllı kart kütüphanesi - (Boş bırakabilirsiniz)',
      VALIDATE_CERTIFICATE: 'Sertifika doğrulaması yap?',
      SELECT_TERMINAL: 'Kart okuyucu seçiniz',
      WRAPPER_FILE_PLACE_HOLDER: 'Akıllı kart kütüphanesinin bilgisayardaki yolunu giriniz',
      CHOOSE_CERTIFICATE: 'Sertifika Seçiniz',
      CERTIFICATE_EXPIRED: 'Sertifika süresi <b><i>{expireDate}</i></b> tarihinde dolmuş!'
    },
    WRAPPER_ALERT: {
      DOWNLOAD_AKIS: 'AKİS yazılımını indirmek için <a href={link} target="_parent">tıklayınız</a>',
      AKIS_NOT_FOUND: 'Bilgisayarınız akis kütüphanesi bulunamadı!',
      AKIS_INSTALL_REQUIRE: 'Akis Kurulumu Gerekiyor',
      AKIS_INSTALL_AFTER_CONTINUE_PROCESS: 'İndirdiğiniz Akis yazılımını kurduktan sonra işleme devam debilirsiniz',
      NOT_INSTALLED_SMART_CARD_SOFTWARE: 'e-İmza Kart okuyucu yazılımı kurulu değil',
      CALL_SMART_CARD_PROVIDER: 'e-İmza sağlayıcınızla görüşmeniz gerekmektedir.'
    },
    ACCOUNT_DETAIL: {
      PARTY_IDENTIFICATION: 'Vergi Kimlik No / T.C. Kimlik No',
      PARTY_NAME: 'Ünvan',
      FIRST_NAME: 'Ad',
      FAMILY_NAME: 'Soyad'
    },
    PROCESS_SELECTION: {
      DESCRIPTION: 'Aktivasyon / DeAktivasyon Yapılacak Ürün Seçiniz'
    },
    SELECTED_ENVELOPE: {
      ID: 'Zarf Numarası'
    },
    BLOCK: {
      MESSAGE: 'e-İmza Uygulaması Kapalı',
      DESCRIPTION: 'İşlem boyunca, e-İmza uygulamasının açık olması gerekmektedir. Lütfen e-İmza uygulamasını tekrar çalıştırınız!'
    },
    CONNECTED: {
      MESSAGE: 'Bağlantı sağlandı',
      DESCRIPTION: 'API bağlantısı başarıyla kuruldu.'
    },
    ACCOUNT_INFO: {
      TITLE: 'HESAP BILGILERI'
    },
    MIGRATION: {
      TITLE: 'Eskiden Yeniye Aktarım'
    },
    CHOOSE: 'Seçiniz...',
    ACTIVATION_STEP: 'Aktivasyon/DeAktivasyon İşlemleri',
    MIGRATIN_STEP: 'Eskiden Yeniye Aktarım Modülü'
  }
);

export default trTR;
